<mat-card class="form-dialogo">
  <app-card-header
    [title]="title"
    [subtitle]="subtitle"
    icono="apartment"
    [draggable]="true"
    [botonCerrar]="true"
    (cerrar)="close()"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <mat-card-content class="card-content-crear">
        <!-- Datos de la base -->
        <app-content-card
          title="Datos de la base de operaciones"
          icon="apartment"
          color="blue"
        >
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="identificacion" />
              <mat-icon matPrefix>badge</mat-icon>
            </mat-form-field>

            @if (mostrarCliente && !id) {
              <app-cliente-selector
                formControlName="idCliente"
                style="width: 100%"
                [filterModules]="['moduloEmergenciasMedicas']"
                [showCrearBtn]="
                  helper.tienePermiso('Administración - Crear clientes')
                "
              ></app-cliente-selector>
            }
          </section>

          <section class="inputs-group">
            <app-checkbox
              title="Activa (puede despachar móviles)"
              formControlName="activo"
              margin="0 16px"
            ></app-checkbox>
          </section>
        </app-content-card>

        <!-- Contacto -->
        <app-content-card title="Contacto" icon="contacts" color="green">
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Teléfono</mat-label>
              <input matInput formControlName="telefono" />
              <mat-icon matPrefix>phone</mat-icon>
            </mat-form-field>

            <mat-form-field style="width: 100%">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" type="email" />
              <mat-icon matPrefix>email</mat-icon>
              @if (form.get('email')?.hasError('email')) {
                <mat-error>Ingresá un email válido</mat-error>
              }
            </mat-form-field>
          </section>
        </app-content-card>

        <!-- Ubicación y cobertura -->
        <app-content-card
          title="Ubicación y área de cobertura"
          [subtitle]="radio ? 'Radio de ' + radio : ''"
          icon="radar"
          color="orange"
        >
          @if (!form.get('geojson')?.value) {
            <app-info-banner
              icon="info"
              color="blue"
              title="Buscá la dirección y dibujá en el mapa el círculo del área que cubre la base."
              [closable]="false"
              margin="0 0 12px 0"
            ></app-info-banner>
          }
          <section class="inputs-group">
            <app-autocomplete-direccion
              style="width: 100%"
              [direccion]="centro?.direccion"
              (direccionChange)="patchDireccion($event)"
              (geoJSONChange)="centrarA = $any($event)"
            ></app-autocomplete-direccion>
          </section>
          <div class="mapa-embebido-wrapper">
            <app-circle-editor-mapbox
              [centrarA]="centrarA"
              [circle]="circulo"
              [color]="colorTema"
              (circleChange)="onCircleChange($event)"
            ></app-circle-editor-mapbox>
          </div>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="close()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
          [disabled]="!form.valid || guardando"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario…" [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
